import * as React from "react";
import {cx} from "emotion";

import "./editing-panel.scss";

import {cs}               from "@Common/react/chain-services";
import {UseState}         from "@Common/react/use-state";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";

import {Checkbox}    from "../../../../../../../../common/design2/checkbox/checkbox";
import {NamingPanel} from "../../../../../common/naming-panel/naming-panel";

export const EditingPanel = ({getInitData, showErrors: showErrors1, count, onCancel, onApply, onApplyAll}) => cs(
    ["data", (_, next) => UseState({getInitValue: getInitData, next})],
    ["eh", (_, next) => ErrorHighlighter({next})],
    ["showErrors", (_, next) => UseState({next})],
    ["applyAllEnabled", (_, next) => UseState({next})],
    ({data, eh, showErrors, applyAllEnabled}) => (
        <div className="editing-panel-458">
            <div className="header" xd-qa-type="label" xd-qa-name="Addressing Options label">
                Addressing Options
            </div>

            {NamingPanel({
                data,
                showErrors: showErrors1 || showErrors.value,
                customNameCss: eh.css,
                controls: (() => {
                    const invalid = (data.value.type === "custom" && !data.value.value);

                    return (
                        <div className="actions-02j">
                            <div className="options">
                                {data.value.type !== "custom" && count > 1 && (
                                    <div
                                        className="apply-to-all"
                                        onClick={() => applyAllEnabled.change(v=>!v)}
                                    >
                                        {Checkbox({
                                            checked: applyAllEnabled.value,
                                        })}
                                        <div className="label">
                                            Apply to all lists created ({count})
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="buttons">
                                <button
                                    className="cancel"
                                    onClick={onCancel}
                                >
                                    CANCEL
                                </button>
                                {cs(
                                    ["submitting", (_, next) => UseState({next})],
                                    ({submitting}) => (
                                        <button
                                            className={cx("apply", {disabled: invalid})}
                                            disabled={submitting.value}
                                            onClick={async () => {
                                                if (invalid) {
                                                    eh.start();
                                                    showErrors.onChange(true);
                                                } else {
                                                    submitting.onChange(true);
                                                    if (applyAllEnabled.value && data.value.type !== "custom") {
                                                        await onApplyAll(data.value);
                                                    } else {
                                                        await onApply(data.value);
                                                    }
                                                    submitting.onChange(false);
                                                }
                                            }}
                                        >
                                            APPLY
                                        </button>
                                    ),
                                )}
                            </div>
                        </div>
                    );
                })(),
            })}

        </div>
    ),
);
